export default __webpack_public_path__ + "static/media/ketogo-logo@3x.d7c3f78f.png";